;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.Share = Model.Share.extend({
		game_type: 'Essendon Tipping',
		defaults: {
			templates: {
				share: {
					title:   _.template('<%= game_type %>'),
					message: _.template('I have just registered for <%= game_type %>! ' +
					'Sign up and join in here'),
					img:     'favicons/apple-icon.png'
				},
				invite: {
					title:   _.template('<%= game_type %>'),
					message: _.template('<%= team %> is entered in <%= league %> league on <%= game_type %>! ' +
					'Join in and start tipping here'),
					img:     'favicons/apple-icon.png'
				}
			}
		}
	});

}(window, APP, Backbone, Marionette, $, _));